import {GROUP_TYPE_UNCLASSIFIED_SUB} from "~/contants/base";

export default async function({ store, redirect, route, app }) {
  const isLogged = store.state.frontend.auth.isLogged
  if (!isLogged) {
    if(process.client) {
      return window.location.href = '/auth/login?redirect=' + encodeURIComponent(route.fullPath);
    } else {
      return redirect('/auth/login?redirect=' + encodeURIComponent(route.fullPath));
    }
  } else {
    const workspace = app.$cookies.get('workspace')
    if (!workspace) {
      if (route.name !== 'workspace') {
        return redirect('/workspace')
      }
    } else {
      let company = store.state.frontend.auth.company;
      if (!company) {
        const { errResponse, data: responseData } = await store.dispatch('frontend/auth/getCompanyPreSetting', workspace)
        if (!errResponse) {
          company = responseData.data

          store.commit('setCompany', company);
        }
      }

      if (company) {
        const groups = store.state.frontend.auth.user.groups;
        if (groups.length === 0
            || groups.find(group => group.type === GROUP_TYPE_UNCLASSIFIED_SUB)) {
          if (route.name !== 'request-group') {
            return redirect('/request-group')
          }
        }
      }
    }
  }
}
